var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"px-0 mb-2"},[_c('v-toolbar',{attrs:{"color":"primary background--text"}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('screener.player.playlist.card.title')))])],1),_c('FilmList',{attrs:{"currentIndex":_vm.currentIndex,"screener":_vm.screener,"showTrailerBtn":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }